import { getProductAvailableQty } from "./product";
import { isWithin } from "./time";
import moment from "moment";

export const getReferralStatus = (referral) => {
  if (isWithin(referral?.time?.collect)) {
    return "ongoing";
  }
  return moment().isAfter(referral?.time?.collect?.end) ? "expired" : "pending";
};

export const formatProductWithAvailableQty = (product, referral = []) => {
  if (!product || !product.id || !product.qty) {
    throw new Error("Invalid product object provided");
  }

  // Calculate available quantity
  const availableQty = product.qty.referral || 0;

  return {
    ...product,
    qty: {
      ...product.qty,
      available: Math.max(availableQty, 0), // Ensure available qty is non-negative
    },
  };
};
